// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dBS","svgDefs":"dBT","canvas":"dBU"};